import { FormName } from './types'

export enum StoreStates {
  START = 'start',
  INITIALIZING = 'initializing',
  INITIALIZED = 'initialized',
  FILLING_FORM = 'filling-form',
  SUBMITTING = 'submitting',
  SUBMITTED = 'submitted',
}

export enum SummaryStates {
  WAITING = 'waiting',
  CALCULATING = 'calculating',
  ERROR = 'error',
  OK = 'ok',
}

export enum CouponStates {
  READY = 'ready',
  APPLYING = 'applying',
  APPLIED = 'applied',
  ERROR = 'error',
}

export enum SubmittingStates {
  IDLE = 'idle',
  START = 'start',
  WAITING_ON_QUEUE = 'waiting-on-queue',
  ERROR = 'error',
  DONE = 'done',
}

export const stripeElementsForms: FormName[] = ['linkAuthentication', 'shipping', 'billing', 'payment']

export const FORM_STRUCTURE_BY_TOTAL_STEPS: Record<1 | 2 | 3, FormName[][]> = {
  1: [['linkAuthentication', 'shipping', 'billing', 'shippingOption', 'products', 'payment', 'tos']],
  2: [
    ['linkAuthentication', 'contact'],
    ['shipping', 'billing', 'shippingOption', 'products', 'payment', 'tos'],
  ],
  3: [['products'], ['linkAuthentication', 'contact'], ['shipping', 'billing', 'shippingOption', 'payment', 'tos']],
}
